import {
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_BEGIN,
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_SUCCESS,
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_FAILURE,
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
export function updateCollectionForAirtable(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_BEGIN,
    });
    const { version, projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/airtable/update-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_SUCCESS,
            data: res,
          });
          toast.success('Collection Updated Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_FAILURE,
            data: { error: err },
          });
          toast.error(`Failed: to Update Collection`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateCollectionForAirtableError() {
  return {
    type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_BEGIN:
      return {
        ...state,
        updateCollectionForAirtablePending: true,
        updateCollectionForAirtableError: null,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_SUCCESS:
      return {
        ...state,
        updateCollectionForAirtablePending: false,
        updateCollectionForAirtableError: null,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_FAILURE:
      return {
        ...state,
        updateCollectionForAirtablePending: false,
        updateCollectionForAirtableError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_AIRTABLE_DISMISS_ERROR:
      return {
        ...state,
        updateCollectionForAirtableError: null,
      };

    default:
      return state;
  }
}
